"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var language_pipe_1 = require("./language.pipe");
var markdown_component_1 = require("./markdown.component");
var markdown_pipe_1 = require("./markdown.pipe");
var markdown_service_1 = require("./markdown.service");
var marked_options_1 = require("./marked-options");
exports.initialMarkedOptions = {
    provide: marked_options_1.MarkedOptions,
    useValue: {
        gfm: true,
        tables: true,
        breaks: false,
        pedantic: false,
        sanitize: false,
        smartLists: true,
        smartypants: false,
    },
};
var MarkdownModule = /** @class */ (function () {
    function MarkdownModule() {
    }
    MarkdownModule.forRoot = function (markedOptions) {
        return {
            ngModule: MarkdownModule,
            providers: [
                markdown_service_1.MarkdownService,
                markedOptions || exports.initialMarkedOptions,
            ],
        };
    };
    MarkdownModule.forChild = function () {
        return {
            ngModule: MarkdownModule,
        };
    };
    MarkdownModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [http_1.HttpClientModule],
                    exports: [
                        language_pipe_1.LanguagePipe,
                        markdown_component_1.MarkdownComponent,
                        markdown_pipe_1.MarkdownPipe,
                    ],
                    declarations: [
                        language_pipe_1.LanguagePipe,
                        markdown_component_1.MarkdownComponent,
                        markdown_pipe_1.MarkdownPipe,
                    ],
                },] },
    ];
    return MarkdownModule;
}());
exports.MarkdownModule = MarkdownModule;
//# sourceMappingURL=markdown.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-markdown/dist/lib/markdown.module.js
// module id = ./node_modules/ngx-markdown/dist/lib/markdown.module.js
// module chunks = vendor